// extracted by mini-css-extract-plugin
export default {"HomeViewComponent":"HomeView_HomeViewComponent__62J8u","welcome":"HomeView_welcome__Zi3l8","user":"HomeView_user__oGZd0","homeViewContent":"HomeView_homeViewContent__vSdGt"};